import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Context, Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import cx from "classnames";
import store from "store";

import styles from "./index.module.scss";

const ImgSuspended = {
  light: require("assets/img/suspended-light.png"),
  dark: require("assets/img/suspended-dark.png"),
};

const Main: React.FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  const t = useTranslation();
  const [appState] = React.useContext(Context.XtContext);

  const { name } = store.market;
  const marketName = useMemo(() => {
    // CFD 交易对带 _cfd 后缀，用 formatCfdName 显示为 BTC/AED；现货用 formatName
    return /_cfd$/i.test(name || "") ? store.market.formatCfdName(name) : store.market.formatName(name);
  }, [name]); // eslint-disable-line react-hooks/exhaustive-deps

  // 停盘：tradingEnabled=false 或 币对 state=OFFLINE（下线）
  const { tradingEnabled, state } = store.market.currentConfig;
  const isSuspended = tradingEnabled === false || state === "OFFLINE";
  if (!isSuspended) return <></>;

  return (
    <div className={cx(styles.main, className)} {...rest}>
      {/*eslint-disable-next-line  @next/next/no-img-element*/}
      <img src={ImgSuspended[appState.theme]} alt={"suspended icon"} />
      <p>{marketName}</p>
      <div>{t("trade.suspended")}</div>
    </div>
  );
};

export default observer(Main);
